// eslint-disable-next-line jira/import-whitelist
import { announcementBannerSettingsV4Resource } from '@jira/admin-pages__system-announcement-banner-resources/src/useAnnouncementBannerSettingsV4Resource.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { getConsentBannerUserPreferencesResource } from '@atlassian/jira-router-resources-cookie-consent/src/index.tsx';
import { incomingMailServerExpiryStatusResource } from '@atlassian/jira-router-resources-incoming-mail-expiry-status/src/services/index.tsx';
import { standardTrialTransactionAccountStatusResource } from '@atlassian/jira-router-resources-standard-trial-transaction-account-status/src/services/index.tsx';
import { resourceWithCondition } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import type { RouteResource } from '@atlassian/react-resource-router';

/**
 * Data for various banners that may or may not appear on page load. Eventually these should all disappear in to one of two places:
 *
 * 1. A top-level Jira SPA query, or
 * 2. A route-specific resource that gets rendered via a portal in to the banner location in page layout.
 *
 * @see `src/packages/page-container-v2/src/common/ui/banner`
 */
export const getBannerResources = (): RouteResource[] => [
	getConsentBannerUserPreferencesResource(),
	announcementBannerSettingsV4Resource,
	incomingMailServerExpiryStatusResource,
	// Auto Upgrade Not a Trial Banner Resource
	resourceWithCondition(
		() => fg('auto_upgrade_not_a_trial_jira_gate'),
		standardTrialTransactionAccountStatusResource,
	),
];
